/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const t$3 = window, e$8 = t$3.ShadowRoot && (void 0 === t$3.ShadyCSS || t$3.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, s$7 = Symbol(), n$7 = /* @__PURE__ */ new WeakMap();
let o$6 = class o {
  constructor(t2, e2, n2) {
    if (this._$cssResult$ = true, n2 !== s$7)
      throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
    this.cssText = t2, this.t = e2;
  }
  get styleSheet() {
    let t2 = this.o;
    const s3 = this.t;
    if (e$8 && void 0 === t2) {
      const e2 = void 0 !== s3 && 1 === s3.length;
      e2 && (t2 = n$7.get(s3)), void 0 === t2 && ((this.o = t2 = new CSSStyleSheet()).replaceSync(this.cssText), e2 && n$7.set(s3, t2));
    }
    return t2;
  }
  toString() {
    return this.cssText;
  }
};
const r$5 = (t2) => new o$6("string" == typeof t2 ? t2 : t2 + "", void 0, s$7), S$3 = (s3, n2) => {
  e$8 ? s3.adoptedStyleSheets = n2.map((t2) => t2 instanceof CSSStyleSheet ? t2 : t2.styleSheet) : n2.forEach((e2) => {
    const n3 = document.createElement("style"), o4 = t$3.litNonce;
    void 0 !== o4 && n3.setAttribute("nonce", o4), n3.textContent = e2.cssText, s3.appendChild(n3);
  });
}, c$4 = e$8 ? (t2) => t2 : (t2) => t2 instanceof CSSStyleSheet ? ((t3) => {
  let e2 = "";
  for (const s3 of t3.cssRules)
    e2 += s3.cssText;
  return r$5(e2);
})(t2) : t2;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var s$6;
const e$7 = window, r$4 = e$7.trustedTypes, h$4 = r$4 ? r$4.emptyScript : "", o$5 = e$7.reactiveElementPolyfillSupport, n$6 = { toAttribute(t2, i2) {
  switch (i2) {
    case Boolean:
      t2 = t2 ? h$4 : null;
      break;
    case Object:
    case Array:
      t2 = null == t2 ? t2 : JSON.stringify(t2);
  }
  return t2;
}, fromAttribute(t2, i2) {
  let s3 = t2;
  switch (i2) {
    case Boolean:
      s3 = null !== t2;
      break;
    case Number:
      s3 = null === t2 ? null : Number(t2);
      break;
    case Object:
    case Array:
      try {
        s3 = JSON.parse(t2);
      } catch (t3) {
        s3 = null;
      }
  }
  return s3;
} }, a$4 = (t2, i2) => i2 !== t2 && (i2 == i2 || t2 == t2), l$6 = { attribute: true, type: String, converter: n$6, reflect: false, hasChanged: a$4 };
let d$4 = class d extends HTMLElement {
  constructor() {
    super(), this._$Ei = /* @__PURE__ */ new Map(), this.isUpdatePending = false, this.hasUpdated = false, this._$El = null, this.u();
  }
  static addInitializer(t2) {
    var i2;
    this.finalize(), (null !== (i2 = this.h) && void 0 !== i2 ? i2 : this.h = []).push(t2);
  }
  static get observedAttributes() {
    this.finalize();
    const t2 = [];
    return this.elementProperties.forEach((i2, s3) => {
      const e2 = this._$Ep(s3, i2);
      void 0 !== e2 && (this._$Ev.set(e2, s3), t2.push(e2));
    }), t2;
  }
  static createProperty(t2, i2 = l$6) {
    if (i2.state && (i2.attribute = false), this.finalize(), this.elementProperties.set(t2, i2), !i2.noAccessor && !this.prototype.hasOwnProperty(t2)) {
      const s3 = "symbol" == typeof t2 ? Symbol() : "__" + t2, e2 = this.getPropertyDescriptor(t2, s3, i2);
      void 0 !== e2 && Object.defineProperty(this.prototype, t2, e2);
    }
  }
  static getPropertyDescriptor(t2, i2, s3) {
    return { get() {
      return this[i2];
    }, set(e2) {
      const r2 = this[t2];
      this[i2] = e2, this.requestUpdate(t2, r2, s3);
    }, configurable: true, enumerable: true };
  }
  static getPropertyOptions(t2) {
    return this.elementProperties.get(t2) || l$6;
  }
  static finalize() {
    if (this.hasOwnProperty("finalized"))
      return false;
    this.finalized = true;
    const t2 = Object.getPrototypeOf(this);
    if (t2.finalize(), void 0 !== t2.h && (this.h = [...t2.h]), this.elementProperties = new Map(t2.elementProperties), this._$Ev = /* @__PURE__ */ new Map(), this.hasOwnProperty("properties")) {
      const t3 = this.properties, i2 = [...Object.getOwnPropertyNames(t3), ...Object.getOwnPropertySymbols(t3)];
      for (const s3 of i2)
        this.createProperty(s3, t3[s3]);
    }
    return this.elementStyles = this.finalizeStyles(this.styles), true;
  }
  static finalizeStyles(i2) {
    const s3 = [];
    if (Array.isArray(i2)) {
      const e2 = new Set(i2.flat(1 / 0).reverse());
      for (const i3 of e2)
        s3.unshift(c$4(i3));
    } else
      void 0 !== i2 && s3.push(c$4(i2));
    return s3;
  }
  static _$Ep(t2, i2) {
    const s3 = i2.attribute;
    return false === s3 ? void 0 : "string" == typeof s3 ? s3 : "string" == typeof t2 ? t2.toLowerCase() : void 0;
  }
  u() {
    var t2;
    this._$E_ = new Promise((t3) => this.enableUpdating = t3), this._$AL = /* @__PURE__ */ new Map(), this._$Eg(), this.requestUpdate(), null === (t2 = this.constructor.h) || void 0 === t2 || t2.forEach((t3) => t3(this));
  }
  addController(t2) {
    var i2, s3;
    (null !== (i2 = this._$ES) && void 0 !== i2 ? i2 : this._$ES = []).push(t2), void 0 !== this.renderRoot && this.isConnected && (null === (s3 = t2.hostConnected) || void 0 === s3 || s3.call(t2));
  }
  removeController(t2) {
    var i2;
    null === (i2 = this._$ES) || void 0 === i2 || i2.splice(this._$ES.indexOf(t2) >>> 0, 1);
  }
  _$Eg() {
    this.constructor.elementProperties.forEach((t2, i2) => {
      this.hasOwnProperty(i2) && (this._$Ei.set(i2, this[i2]), delete this[i2]);
    });
  }
  createRenderRoot() {
    var t2;
    const s3 = null !== (t2 = this.shadowRoot) && void 0 !== t2 ? t2 : this.attachShadow(this.constructor.shadowRootOptions);
    return S$3(s3, this.constructor.elementStyles), s3;
  }
  connectedCallback() {
    var t2;
    void 0 === this.renderRoot && (this.renderRoot = this.createRenderRoot()), this.enableUpdating(true), null === (t2 = this._$ES) || void 0 === t2 || t2.forEach((t3) => {
      var i2;
      return null === (i2 = t3.hostConnected) || void 0 === i2 ? void 0 : i2.call(t3);
    });
  }
  enableUpdating(t2) {
  }
  disconnectedCallback() {
    var t2;
    null === (t2 = this._$ES) || void 0 === t2 || t2.forEach((t3) => {
      var i2;
      return null === (i2 = t3.hostDisconnected) || void 0 === i2 ? void 0 : i2.call(t3);
    });
  }
  attributeChangedCallback(t2, i2, s3) {
    this._$AK(t2, s3);
  }
  _$EO(t2, i2, s3 = l$6) {
    var e2;
    const r2 = this.constructor._$Ep(t2, s3);
    if (void 0 !== r2 && true === s3.reflect) {
      const h2 = (void 0 !== (null === (e2 = s3.converter) || void 0 === e2 ? void 0 : e2.toAttribute) ? s3.converter : n$6).toAttribute(i2, s3.type);
      this._$El = t2, null == h2 ? this.removeAttribute(r2) : this.setAttribute(r2, h2), this._$El = null;
    }
  }
  _$AK(t2, i2) {
    var s3;
    const e2 = this.constructor, r2 = e2._$Ev.get(t2);
    if (void 0 !== r2 && this._$El !== r2) {
      const t3 = e2.getPropertyOptions(r2), h2 = "function" == typeof t3.converter ? { fromAttribute: t3.converter } : void 0 !== (null === (s3 = t3.converter) || void 0 === s3 ? void 0 : s3.fromAttribute) ? t3.converter : n$6;
      this._$El = r2, this[r2] = h2.fromAttribute(i2, t3.type), this._$El = null;
    }
  }
  requestUpdate(t2, i2, s3) {
    let e2 = true;
    void 0 !== t2 && (((s3 = s3 || this.constructor.getPropertyOptions(t2)).hasChanged || a$4)(this[t2], i2) ? (this._$AL.has(t2) || this._$AL.set(t2, i2), true === s3.reflect && this._$El !== t2 && (void 0 === this._$EC && (this._$EC = /* @__PURE__ */ new Map()), this._$EC.set(t2, s3))) : e2 = false), !this.isUpdatePending && e2 && (this._$E_ = this._$Ej());
  }
  async _$Ej() {
    this.isUpdatePending = true;
    try {
      await this._$E_;
    } catch (t3) {
      Promise.reject(t3);
    }
    const t2 = this.scheduleUpdate();
    return null != t2 && await t2, !this.isUpdatePending;
  }
  scheduleUpdate() {
    return this.performUpdate();
  }
  performUpdate() {
    var t2;
    if (!this.isUpdatePending)
      return;
    this.hasUpdated, this._$Ei && (this._$Ei.forEach((t3, i3) => this[i3] = t3), this._$Ei = void 0);
    let i2 = false;
    const s3 = this._$AL;
    try {
      i2 = this.shouldUpdate(s3), i2 ? (this.willUpdate(s3), null === (t2 = this._$ES) || void 0 === t2 || t2.forEach((t3) => {
        var i3;
        return null === (i3 = t3.hostUpdate) || void 0 === i3 ? void 0 : i3.call(t3);
      }), this.update(s3)) : this._$Ek();
    } catch (t3) {
      throw i2 = false, this._$Ek(), t3;
    }
    i2 && this._$AE(s3);
  }
  willUpdate(t2) {
  }
  _$AE(t2) {
    var i2;
    null === (i2 = this._$ES) || void 0 === i2 || i2.forEach((t3) => {
      var i3;
      return null === (i3 = t3.hostUpdated) || void 0 === i3 ? void 0 : i3.call(t3);
    }), this.hasUpdated || (this.hasUpdated = true, this.firstUpdated(t2)), this.updated(t2);
  }
  _$Ek() {
    this._$AL = /* @__PURE__ */ new Map(), this.isUpdatePending = false;
  }
  get updateComplete() {
    return this.getUpdateComplete();
  }
  getUpdateComplete() {
    return this._$E_;
  }
  shouldUpdate(t2) {
    return true;
  }
  update(t2) {
    void 0 !== this._$EC && (this._$EC.forEach((t3, i2) => this._$EO(i2, this[i2], t3)), this._$EC = void 0), this._$Ek();
  }
  updated(t2) {
  }
  firstUpdated(t2) {
  }
};
d$4.finalized = true, d$4.elementProperties = /* @__PURE__ */ new Map(), d$4.elementStyles = [], d$4.shadowRootOptions = { mode: "open" }, null == o$5 || o$5({ ReactiveElement: d$4 }), (null !== (s$6 = e$7.reactiveElementVersions) && void 0 !== s$6 ? s$6 : e$7.reactiveElementVersions = []).push("1.6.0");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var t$2;
const i$2 = window, s$5 = i$2.trustedTypes, e$6 = s$5 ? s$5.createPolicy("lit-html", { createHTML: (t2) => t2 }) : void 0, o$4 = "$lit$", n$5 = `lit$${(Math.random() + "").slice(9)}$`, l$5 = "?" + n$5, h$3 = `<${l$5}>`, r$3 = document, d$3 = () => r$3.createComment(""), u$2 = (t2) => null === t2 || "object" != typeof t2 && "function" != typeof t2, c$3 = Array.isArray, v$1 = (t2) => c$3(t2) || "function" == typeof (null == t2 ? void 0 : t2[Symbol.iterator]), a$3 = "[ 	\n\f\r]", f$2 = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, _$1 = /-->/g, m$1 = />/g, p$2 = RegExp(`>|${a$3}(?:([^\\s"'>=/]+)(${a$3}*=${a$3}*(?:[^ 	
\f\r"'\`<>=]|("|')|))|$)`, "g"), g$2 = /'/g, $$2 = /"/g, y$2 = /^(?:script|style|textarea|title)$/i, T$2 = Symbol.for("lit-noChange"), A$2 = Symbol.for("lit-nothing"), E$2 = /* @__PURE__ */ new WeakMap(), C$1 = r$3.createTreeWalker(r$3, 129, null, false), P$1 = (t2, i2) => {
  const s3 = t2.length - 1, l2 = [];
  let r2, d4 = 2 === i2 ? "<svg>" : "", u2 = f$2;
  for (let i3 = 0; i3 < s3; i3++) {
    const s4 = t2[i3];
    let e2, c3, v2 = -1, a2 = 0;
    for (; a2 < s4.length && (u2.lastIndex = a2, c3 = u2.exec(s4), null !== c3); )
      a2 = u2.lastIndex, u2 === f$2 ? "!--" === c3[1] ? u2 = _$1 : void 0 !== c3[1] ? u2 = m$1 : void 0 !== c3[2] ? (y$2.test(c3[2]) && (r2 = RegExp("</" + c3[2], "g")), u2 = p$2) : void 0 !== c3[3] && (u2 = p$2) : u2 === p$2 ? ">" === c3[0] ? (u2 = null != r2 ? r2 : f$2, v2 = -1) : void 0 === c3[1] ? v2 = -2 : (v2 = u2.lastIndex - c3[2].length, e2 = c3[1], u2 = void 0 === c3[3] ? p$2 : '"' === c3[3] ? $$2 : g$2) : u2 === $$2 || u2 === g$2 ? u2 = p$2 : u2 === _$1 || u2 === m$1 ? u2 = f$2 : (u2 = p$2, r2 = void 0);
    const w2 = u2 === p$2 && t2[i3 + 1].startsWith("/>") ? " " : "";
    d4 += u2 === f$2 ? s4 + h$3 : v2 >= 0 ? (l2.push(e2), s4.slice(0, v2) + o$4 + s4.slice(v2) + n$5 + w2) : s4 + n$5 + (-2 === v2 ? (l2.push(void 0), i3) : w2);
  }
  const c2 = d4 + (t2[s3] || "<?>") + (2 === i2 ? "</svg>" : "");
  if (!Array.isArray(t2) || !t2.hasOwnProperty("raw"))
    throw Error("invalid template strings array");
  return [void 0 !== e$6 ? e$6.createHTML(c2) : c2, l2];
};
let V$2 = class V {
  constructor({ strings: t2, _$litType$: i2 }, e2) {
    let h2;
    this.parts = [];
    let r2 = 0, u2 = 0;
    const c2 = t2.length - 1, v2 = this.parts, [a2, f2] = P$1(t2, i2);
    if (this.el = V.createElement(a2, e2), C$1.currentNode = this.el.content, 2 === i2) {
      const t3 = this.el.content, i3 = t3.firstChild;
      i3.remove(), t3.append(...i3.childNodes);
    }
    for (; null !== (h2 = C$1.nextNode()) && v2.length < c2; ) {
      if (1 === h2.nodeType) {
        if (h2.hasAttributes()) {
          const t3 = [];
          for (const i3 of h2.getAttributeNames())
            if (i3.endsWith(o$4) || i3.startsWith(n$5)) {
              const s3 = f2[u2++];
              if (t3.push(i3), void 0 !== s3) {
                const t4 = h2.getAttribute(s3.toLowerCase() + o$4).split(n$5), i4 = /([.?@])?(.*)/.exec(s3);
                v2.push({ type: 1, index: r2, name: i4[2], strings: t4, ctor: "." === i4[1] ? k$1 : "?" === i4[1] ? I$2 : "@" === i4[1] ? L$2 : R$2 });
              } else
                v2.push({ type: 6, index: r2 });
            }
          for (const i3 of t3)
            h2.removeAttribute(i3);
        }
        if (y$2.test(h2.tagName)) {
          const t3 = h2.textContent.split(n$5), i3 = t3.length - 1;
          if (i3 > 0) {
            h2.textContent = s$5 ? s$5.emptyScript : "";
            for (let s3 = 0; s3 < i3; s3++)
              h2.append(t3[s3], d$3()), C$1.nextNode(), v2.push({ type: 2, index: ++r2 });
            h2.append(t3[i3], d$3());
          }
        }
      } else if (8 === h2.nodeType)
        if (h2.data === l$5)
          v2.push({ type: 2, index: r2 });
        else {
          let t3 = -1;
          for (; -1 !== (t3 = h2.data.indexOf(n$5, t3 + 1)); )
            v2.push({ type: 7, index: r2 }), t3 += n$5.length - 1;
        }
      r2++;
    }
  }
  static createElement(t2, i2) {
    const s3 = r$3.createElement("template");
    return s3.innerHTML = t2, s3;
  }
};
function N$1(t2, i2, s3 = t2, e2) {
  var o4, n2, l2, h2;
  if (i2 === T$2)
    return i2;
  let r2 = void 0 !== e2 ? null === (o4 = s3._$Co) || void 0 === o4 ? void 0 : o4[e2] : s3._$Cl;
  const d4 = u$2(i2) ? void 0 : i2._$litDirective$;
  return (null == r2 ? void 0 : r2.constructor) !== d4 && (null === (n2 = null == r2 ? void 0 : r2._$AO) || void 0 === n2 || n2.call(r2, false), void 0 === d4 ? r2 = void 0 : (r2 = new d4(t2), r2._$AT(t2, s3, e2)), void 0 !== e2 ? (null !== (l2 = (h2 = s3)._$Co) && void 0 !== l2 ? l2 : h2._$Co = [])[e2] = r2 : s3._$Cl = r2), void 0 !== r2 && (i2 = N$1(t2, r2._$AS(t2, i2.values), r2, e2)), i2;
}
let S$2 = class S {
  constructor(t2, i2) {
    this.u = [], this._$AN = void 0, this._$AD = t2, this._$AM = i2;
  }
  get parentNode() {
    return this._$AM.parentNode;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  v(t2) {
    var i2;
    const { el: { content: s3 }, parts: e2 } = this._$AD, o4 = (null !== (i2 = null == t2 ? void 0 : t2.creationScope) && void 0 !== i2 ? i2 : r$3).importNode(s3, true);
    C$1.currentNode = o4;
    let n2 = C$1.nextNode(), l2 = 0, h2 = 0, d4 = e2[0];
    for (; void 0 !== d4; ) {
      if (l2 === d4.index) {
        let i3;
        2 === d4.type ? i3 = new M$2(n2, n2.nextSibling, this, t2) : 1 === d4.type ? i3 = new d4.ctor(n2, d4.name, d4.strings, this, t2) : 6 === d4.type && (i3 = new z$2(n2, this, t2)), this.u.push(i3), d4 = e2[++h2];
      }
      l2 !== (null == d4 ? void 0 : d4.index) && (n2 = C$1.nextNode(), l2++);
    }
    return o4;
  }
  p(t2) {
    let i2 = 0;
    for (const s3 of this.u)
      void 0 !== s3 && (void 0 !== s3.strings ? (s3._$AI(t2, s3, i2), i2 += s3.strings.length - 2) : s3._$AI(t2[i2])), i2++;
  }
};
let M$2 = class M {
  constructor(t2, i2, s3, e2) {
    var o4;
    this.type = 2, this._$AH = A$2, this._$AN = void 0, this._$AA = t2, this._$AB = i2, this._$AM = s3, this.options = e2, this._$Cm = null === (o4 = null == e2 ? void 0 : e2.isConnected) || void 0 === o4 || o4;
  }
  get _$AU() {
    var t2, i2;
    return null !== (i2 = null === (t2 = this._$AM) || void 0 === t2 ? void 0 : t2._$AU) && void 0 !== i2 ? i2 : this._$Cm;
  }
  get parentNode() {
    let t2 = this._$AA.parentNode;
    const i2 = this._$AM;
    return void 0 !== i2 && 11 === (null == t2 ? void 0 : t2.nodeType) && (t2 = i2.parentNode), t2;
  }
  get startNode() {
    return this._$AA;
  }
  get endNode() {
    return this._$AB;
  }
  _$AI(t2, i2 = this) {
    t2 = N$1(this, t2, i2), u$2(t2) ? t2 === A$2 || null == t2 || "" === t2 ? (this._$AH !== A$2 && this._$AR(), this._$AH = A$2) : t2 !== this._$AH && t2 !== T$2 && this.g(t2) : void 0 !== t2._$litType$ ? this.$(t2) : void 0 !== t2.nodeType ? this.T(t2) : v$1(t2) ? this.k(t2) : this.g(t2);
  }
  S(t2) {
    return this._$AA.parentNode.insertBefore(t2, this._$AB);
  }
  T(t2) {
    this._$AH !== t2 && (this._$AR(), this._$AH = this.S(t2));
  }
  g(t2) {
    this._$AH !== A$2 && u$2(this._$AH) ? this._$AA.nextSibling.data = t2 : this.T(r$3.createTextNode(t2)), this._$AH = t2;
  }
  $(t2) {
    var i2;
    const { values: s3, _$litType$: e2 } = t2, o4 = "number" == typeof e2 ? this._$AC(t2) : (void 0 === e2.el && (e2.el = V$2.createElement(e2.h, this.options)), e2);
    if ((null === (i2 = this._$AH) || void 0 === i2 ? void 0 : i2._$AD) === o4)
      this._$AH.p(s3);
    else {
      const t3 = new S$2(o4, this), i3 = t3.v(this.options);
      t3.p(s3), this.T(i3), this._$AH = t3;
    }
  }
  _$AC(t2) {
    let i2 = E$2.get(t2.strings);
    return void 0 === i2 && E$2.set(t2.strings, i2 = new V$2(t2)), i2;
  }
  k(t2) {
    c$3(this._$AH) || (this._$AH = [], this._$AR());
    const i2 = this._$AH;
    let s3, e2 = 0;
    for (const o4 of t2)
      e2 === i2.length ? i2.push(s3 = new M(this.S(d$3()), this.S(d$3()), this, this.options)) : s3 = i2[e2], s3._$AI(o4), e2++;
    e2 < i2.length && (this._$AR(s3 && s3._$AB.nextSibling, e2), i2.length = e2);
  }
  _$AR(t2 = this._$AA.nextSibling, i2) {
    var s3;
    for (null === (s3 = this._$AP) || void 0 === s3 || s3.call(this, false, true, i2); t2 && t2 !== this._$AB; ) {
      const i3 = t2.nextSibling;
      t2.remove(), t2 = i3;
    }
  }
  setConnected(t2) {
    var i2;
    void 0 === this._$AM && (this._$Cm = t2, null === (i2 = this._$AP) || void 0 === i2 || i2.call(this, t2));
  }
};
let R$2 = class R {
  constructor(t2, i2, s3, e2, o4) {
    this.type = 1, this._$AH = A$2, this._$AN = void 0, this.element = t2, this.name = i2, this._$AM = e2, this.options = o4, s3.length > 2 || "" !== s3[0] || "" !== s3[1] ? (this._$AH = Array(s3.length - 1).fill(new String()), this.strings = s3) : this._$AH = A$2;
  }
  get tagName() {
    return this.element.tagName;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AI(t2, i2 = this, s3, e2) {
    const o4 = this.strings;
    let n2 = false;
    if (void 0 === o4)
      t2 = N$1(this, t2, i2, 0), n2 = !u$2(t2) || t2 !== this._$AH && t2 !== T$2, n2 && (this._$AH = t2);
    else {
      const e3 = t2;
      let l2, h2;
      for (t2 = o4[0], l2 = 0; l2 < o4.length - 1; l2++)
        h2 = N$1(this, e3[s3 + l2], i2, l2), h2 === T$2 && (h2 = this._$AH[l2]), n2 || (n2 = !u$2(h2) || h2 !== this._$AH[l2]), h2 === A$2 ? t2 = A$2 : t2 !== A$2 && (t2 += (null != h2 ? h2 : "") + o4[l2 + 1]), this._$AH[l2] = h2;
    }
    n2 && !e2 && this.j(t2);
  }
  j(t2) {
    t2 === A$2 ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, null != t2 ? t2 : "");
  }
};
let k$1 = class k extends R$2 {
  constructor() {
    super(...arguments), this.type = 3;
  }
  j(t2) {
    this.element[this.name] = t2 === A$2 ? void 0 : t2;
  }
};
const H$1 = s$5 ? s$5.emptyScript : "";
let I$2 = class I extends R$2 {
  constructor() {
    super(...arguments), this.type = 4;
  }
  j(t2) {
    t2 && t2 !== A$2 ? this.element.setAttribute(this.name, H$1) : this.element.removeAttribute(this.name);
  }
};
let L$2 = class L extends R$2 {
  constructor(t2, i2, s3, e2, o4) {
    super(t2, i2, s3, e2, o4), this.type = 5;
  }
  _$AI(t2, i2 = this) {
    var s3;
    if ((t2 = null !== (s3 = N$1(this, t2, i2, 0)) && void 0 !== s3 ? s3 : A$2) === T$2)
      return;
    const e2 = this._$AH, o4 = t2 === A$2 && e2 !== A$2 || t2.capture !== e2.capture || t2.once !== e2.once || t2.passive !== e2.passive, n2 = t2 !== A$2 && (e2 === A$2 || o4);
    o4 && this.element.removeEventListener(this.name, this, e2), n2 && this.element.addEventListener(this.name, this, t2), this._$AH = t2;
  }
  handleEvent(t2) {
    var i2, s3;
    "function" == typeof this._$AH ? this._$AH.call(null !== (s3 = null === (i2 = this.options) || void 0 === i2 ? void 0 : i2.host) && void 0 !== s3 ? s3 : this.element, t2) : this._$AH.handleEvent(t2);
  }
};
let z$2 = class z {
  constructor(t2, i2, s3) {
    this.element = t2, this.type = 6, this._$AN = void 0, this._$AM = i2, this.options = s3;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AI(t2) {
    N$1(this, t2);
  }
};
const j$1 = i$2.litHtmlPolyfillSupport;
null == j$1 || j$1(V$2, M$2), (null !== (t$2 = i$2.litHtmlVersions) && void 0 !== t$2 ? t$2 : i$2.litHtmlVersions = []).push("2.7.0");
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const t$1 = window, e$5 = t$1.ShadowRoot && (void 0 === t$1.ShadyCSS || t$1.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, s$4 = Symbol(), n$4 = /* @__PURE__ */ new WeakMap();
let o$3 = class o2 {
  constructor(t2, e2, n2) {
    if (this._$cssResult$ = true, n2 !== s$4)
      throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
    this.cssText = t2, this.t = e2;
  }
  get styleSheet() {
    let t2 = this.o;
    const s3 = this.t;
    if (e$5 && void 0 === t2) {
      const e2 = void 0 !== s3 && 1 === s3.length;
      e2 && (t2 = n$4.get(s3)), void 0 === t2 && ((this.o = t2 = new CSSStyleSheet()).replaceSync(this.cssText), e2 && n$4.set(s3, t2));
    }
    return t2;
  }
  toString() {
    return this.cssText;
  }
};
const r$2 = (t2) => new o$3("string" == typeof t2 ? t2 : t2 + "", void 0, s$4), S$1 = (s3, n2) => {
  e$5 ? s3.adoptedStyleSheets = n2.map((t2) => t2 instanceof CSSStyleSheet ? t2 : t2.styleSheet) : n2.forEach((e2) => {
    const n3 = document.createElement("style"), o4 = t$1.litNonce;
    void 0 !== o4 && n3.setAttribute("nonce", o4), n3.textContent = e2.cssText, s3.appendChild(n3);
  });
}, c$2 = e$5 ? (t2) => t2 : (t2) => t2 instanceof CSSStyleSheet ? ((t3) => {
  let e2 = "";
  for (const s3 of t3.cssRules)
    e2 += s3.cssText;
  return r$2(e2);
})(t2) : t2;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var s$3;
const e$4 = window, r$1 = e$4.trustedTypes, h$2 = r$1 ? r$1.emptyScript : "", o$2 = e$4.reactiveElementPolyfillSupport, n$3 = { toAttribute(t2, i2) {
  switch (i2) {
    case Boolean:
      t2 = t2 ? h$2 : null;
      break;
    case Object:
    case Array:
      t2 = null == t2 ? t2 : JSON.stringify(t2);
  }
  return t2;
}, fromAttribute(t2, i2) {
  let s3 = t2;
  switch (i2) {
    case Boolean:
      s3 = null !== t2;
      break;
    case Number:
      s3 = null === t2 ? null : Number(t2);
      break;
    case Object:
    case Array:
      try {
        s3 = JSON.parse(t2);
      } catch (t3) {
        s3 = null;
      }
  }
  return s3;
} }, a$2 = (t2, i2) => i2 !== t2 && (i2 == i2 || t2 == t2), l$4 = { attribute: true, type: String, converter: n$3, reflect: false, hasChanged: a$2 };
let d$2 = class d2 extends HTMLElement {
  constructor() {
    super(), this._$Ei = /* @__PURE__ */ new Map(), this.isUpdatePending = false, this.hasUpdated = false, this._$El = null, this.u();
  }
  static addInitializer(t2) {
    var i2;
    this.finalize(), (null !== (i2 = this.h) && void 0 !== i2 ? i2 : this.h = []).push(t2);
  }
  static get observedAttributes() {
    this.finalize();
    const t2 = [];
    return this.elementProperties.forEach((i2, s3) => {
      const e2 = this._$Ep(s3, i2);
      void 0 !== e2 && (this._$Ev.set(e2, s3), t2.push(e2));
    }), t2;
  }
  static createProperty(t2, i2 = l$4) {
    if (i2.state && (i2.attribute = false), this.finalize(), this.elementProperties.set(t2, i2), !i2.noAccessor && !this.prototype.hasOwnProperty(t2)) {
      const s3 = "symbol" == typeof t2 ? Symbol() : "__" + t2, e2 = this.getPropertyDescriptor(t2, s3, i2);
      void 0 !== e2 && Object.defineProperty(this.prototype, t2, e2);
    }
  }
  static getPropertyDescriptor(t2, i2, s3) {
    return { get() {
      return this[i2];
    }, set(e2) {
      const r2 = this[t2];
      this[i2] = e2, this.requestUpdate(t2, r2, s3);
    }, configurable: true, enumerable: true };
  }
  static getPropertyOptions(t2) {
    return this.elementProperties.get(t2) || l$4;
  }
  static finalize() {
    if (this.hasOwnProperty("finalized"))
      return false;
    this.finalized = true;
    const t2 = Object.getPrototypeOf(this);
    if (t2.finalize(), void 0 !== t2.h && (this.h = [...t2.h]), this.elementProperties = new Map(t2.elementProperties), this._$Ev = /* @__PURE__ */ new Map(), this.hasOwnProperty("properties")) {
      const t3 = this.properties, i2 = [...Object.getOwnPropertyNames(t3), ...Object.getOwnPropertySymbols(t3)];
      for (const s3 of i2)
        this.createProperty(s3, t3[s3]);
    }
    return this.elementStyles = this.finalizeStyles(this.styles), true;
  }
  static finalizeStyles(i2) {
    const s3 = [];
    if (Array.isArray(i2)) {
      const e2 = new Set(i2.flat(1 / 0).reverse());
      for (const i3 of e2)
        s3.unshift(c$2(i3));
    } else
      void 0 !== i2 && s3.push(c$2(i2));
    return s3;
  }
  static _$Ep(t2, i2) {
    const s3 = i2.attribute;
    return false === s3 ? void 0 : "string" == typeof s3 ? s3 : "string" == typeof t2 ? t2.toLowerCase() : void 0;
  }
  u() {
    var t2;
    this._$E_ = new Promise((t3) => this.enableUpdating = t3), this._$AL = /* @__PURE__ */ new Map(), this._$Eg(), this.requestUpdate(), null === (t2 = this.constructor.h) || void 0 === t2 || t2.forEach((t3) => t3(this));
  }
  addController(t2) {
    var i2, s3;
    (null !== (i2 = this._$ES) && void 0 !== i2 ? i2 : this._$ES = []).push(t2), void 0 !== this.renderRoot && this.isConnected && (null === (s3 = t2.hostConnected) || void 0 === s3 || s3.call(t2));
  }
  removeController(t2) {
    var i2;
    null === (i2 = this._$ES) || void 0 === i2 || i2.splice(this._$ES.indexOf(t2) >>> 0, 1);
  }
  _$Eg() {
    this.constructor.elementProperties.forEach((t2, i2) => {
      this.hasOwnProperty(i2) && (this._$Ei.set(i2, this[i2]), delete this[i2]);
    });
  }
  createRenderRoot() {
    var t2;
    const s3 = null !== (t2 = this.shadowRoot) && void 0 !== t2 ? t2 : this.attachShadow(this.constructor.shadowRootOptions);
    return S$1(s3, this.constructor.elementStyles), s3;
  }
  connectedCallback() {
    var t2;
    void 0 === this.renderRoot && (this.renderRoot = this.createRenderRoot()), this.enableUpdating(true), null === (t2 = this._$ES) || void 0 === t2 || t2.forEach((t3) => {
      var i2;
      return null === (i2 = t3.hostConnected) || void 0 === i2 ? void 0 : i2.call(t3);
    });
  }
  enableUpdating(t2) {
  }
  disconnectedCallback() {
    var t2;
    null === (t2 = this._$ES) || void 0 === t2 || t2.forEach((t3) => {
      var i2;
      return null === (i2 = t3.hostDisconnected) || void 0 === i2 ? void 0 : i2.call(t3);
    });
  }
  attributeChangedCallback(t2, i2, s3) {
    this._$AK(t2, s3);
  }
  _$EO(t2, i2, s3 = l$4) {
    var e2;
    const r2 = this.constructor._$Ep(t2, s3);
    if (void 0 !== r2 && true === s3.reflect) {
      const h2 = (void 0 !== (null === (e2 = s3.converter) || void 0 === e2 ? void 0 : e2.toAttribute) ? s3.converter : n$3).toAttribute(i2, s3.type);
      this._$El = t2, null == h2 ? this.removeAttribute(r2) : this.setAttribute(r2, h2), this._$El = null;
    }
  }
  _$AK(t2, i2) {
    var s3;
    const e2 = this.constructor, r2 = e2._$Ev.get(t2);
    if (void 0 !== r2 && this._$El !== r2) {
      const t3 = e2.getPropertyOptions(r2), h2 = "function" == typeof t3.converter ? { fromAttribute: t3.converter } : void 0 !== (null === (s3 = t3.converter) || void 0 === s3 ? void 0 : s3.fromAttribute) ? t3.converter : n$3;
      this._$El = r2, this[r2] = h2.fromAttribute(i2, t3.type), this._$El = null;
    }
  }
  requestUpdate(t2, i2, s3) {
    let e2 = true;
    void 0 !== t2 && (((s3 = s3 || this.constructor.getPropertyOptions(t2)).hasChanged || a$2)(this[t2], i2) ? (this._$AL.has(t2) || this._$AL.set(t2, i2), true === s3.reflect && this._$El !== t2 && (void 0 === this._$EC && (this._$EC = /* @__PURE__ */ new Map()), this._$EC.set(t2, s3))) : e2 = false), !this.isUpdatePending && e2 && (this._$E_ = this._$Ej());
  }
  async _$Ej() {
    this.isUpdatePending = true;
    try {
      await this._$E_;
    } catch (t3) {
      Promise.reject(t3);
    }
    const t2 = this.scheduleUpdate();
    return null != t2 && await t2, !this.isUpdatePending;
  }
  scheduleUpdate() {
    return this.performUpdate();
  }
  performUpdate() {
    var t2;
    if (!this.isUpdatePending)
      return;
    this.hasUpdated, this._$Ei && (this._$Ei.forEach((t3, i3) => this[i3] = t3), this._$Ei = void 0);
    let i2 = false;
    const s3 = this._$AL;
    try {
      i2 = this.shouldUpdate(s3), i2 ? (this.willUpdate(s3), null === (t2 = this._$ES) || void 0 === t2 || t2.forEach((t3) => {
        var i3;
        return null === (i3 = t3.hostUpdate) || void 0 === i3 ? void 0 : i3.call(t3);
      }), this.update(s3)) : this._$Ek();
    } catch (t3) {
      throw i2 = false, this._$Ek(), t3;
    }
    i2 && this._$AE(s3);
  }
  willUpdate(t2) {
  }
  _$AE(t2) {
    var i2;
    null === (i2 = this._$ES) || void 0 === i2 || i2.forEach((t3) => {
      var i3;
      return null === (i3 = t3.hostUpdated) || void 0 === i3 ? void 0 : i3.call(t3);
    }), this.hasUpdated || (this.hasUpdated = true, this.firstUpdated(t2)), this.updated(t2);
  }
  _$Ek() {
    this._$AL = /* @__PURE__ */ new Map(), this.isUpdatePending = false;
  }
  get updateComplete() {
    return this.getUpdateComplete();
  }
  getUpdateComplete() {
    return this._$E_;
  }
  shouldUpdate(t2) {
    return true;
  }
  update(t2) {
    void 0 !== this._$EC && (this._$EC.forEach((t3, i2) => this._$EO(i2, this[i2], t3)), this._$EC = void 0), this._$Ek();
  }
  updated(t2) {
  }
  firstUpdated(t2) {
  }
};
d$2.finalized = true, d$2.elementProperties = /* @__PURE__ */ new Map(), d$2.elementStyles = [], d$2.shadowRootOptions = { mode: "open" }, null == o$2 || o$2({ ReactiveElement: d$2 }), (null !== (s$3 = e$4.reactiveElementVersions) && void 0 !== s$3 ? s$3 : e$4.reactiveElementVersions = []).push("1.5.0");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var t;
const i$1 = window, s$2 = i$1.trustedTypes, e$3 = s$2 ? s$2.createPolicy("lit-html", { createHTML: (t2) => t2 }) : void 0, o$1 = "$lit$", n$2 = `lit$${(Math.random() + "").slice(9)}$`, l$3 = "?" + n$2, h$1 = `<${l$3}>`, r = document, d$1 = () => r.createComment(""), u$1 = (t2) => null === t2 || "object" != typeof t2 && "function" != typeof t2, c$1 = Array.isArray, v = (t2) => c$1(t2) || "function" == typeof (null == t2 ? void 0 : t2[Symbol.iterator]), a$1 = "[ 	\n\f\r]", f$1 = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, _ = /-->/g, m = />/g, p$1 = RegExp(`>|${a$1}(?:([^\\s"'>=/]+)(${a$1}*=${a$1}*(?:[^ 	
\f\r"'\`<>=]|("|')|))|$)`, "g"), g$1 = /'/g, $$1 = /"/g, y$1 = /^(?:script|style|textarea|title)$/i, w$1 = (t2) => (i2, ...s3) => ({ _$litType$: t2, strings: i2, values: s3 }), x$1 = w$1(1), T$1 = Symbol.for("lit-noChange"), A$1 = Symbol.for("lit-nothing"), E$1 = /* @__PURE__ */ new WeakMap(), C = r.createTreeWalker(r, 129, null, false), P = (t2, i2) => {
  const s3 = t2.length - 1, l2 = [];
  let r2, d4 = 2 === i2 ? "<svg>" : "", u2 = f$1;
  for (let i3 = 0; i3 < s3; i3++) {
    const s4 = t2[i3];
    let e2, c3, v2 = -1, a2 = 0;
    for (; a2 < s4.length && (u2.lastIndex = a2, c3 = u2.exec(s4), null !== c3); )
      a2 = u2.lastIndex, u2 === f$1 ? "!--" === c3[1] ? u2 = _ : void 0 !== c3[1] ? u2 = m : void 0 !== c3[2] ? (y$1.test(c3[2]) && (r2 = RegExp("</" + c3[2], "g")), u2 = p$1) : void 0 !== c3[3] && (u2 = p$1) : u2 === p$1 ? ">" === c3[0] ? (u2 = null != r2 ? r2 : f$1, v2 = -1) : void 0 === c3[1] ? v2 = -2 : (v2 = u2.lastIndex - c3[2].length, e2 = c3[1], u2 = void 0 === c3[3] ? p$1 : '"' === c3[3] ? $$1 : g$1) : u2 === $$1 || u2 === g$1 ? u2 = p$1 : u2 === _ || u2 === m ? u2 = f$1 : (u2 = p$1, r2 = void 0);
    const w2 = u2 === p$1 && t2[i3 + 1].startsWith("/>") ? " " : "";
    d4 += u2 === f$1 ? s4 + h$1 : v2 >= 0 ? (l2.push(e2), s4.slice(0, v2) + o$1 + s4.slice(v2) + n$2 + w2) : s4 + n$2 + (-2 === v2 ? (l2.push(void 0), i3) : w2);
  }
  const c2 = d4 + (t2[s3] || "<?>") + (2 === i2 ? "</svg>" : "");
  if (!Array.isArray(t2) || !t2.hasOwnProperty("raw"))
    throw Error("invalid template strings array");
  return [void 0 !== e$3 ? e$3.createHTML(c2) : c2, l2];
};
let V$1 = class V2 {
  constructor({ strings: t2, _$litType$: i2 }, e2) {
    let h2;
    this.parts = [];
    let r2 = 0, u2 = 0;
    const c2 = t2.length - 1, v2 = this.parts, [a2, f2] = P(t2, i2);
    if (this.el = V2.createElement(a2, e2), C.currentNode = this.el.content, 2 === i2) {
      const t3 = this.el.content, i3 = t3.firstChild;
      i3.remove(), t3.append(...i3.childNodes);
    }
    for (; null !== (h2 = C.nextNode()) && v2.length < c2; ) {
      if (1 === h2.nodeType) {
        if (h2.hasAttributes()) {
          const t3 = [];
          for (const i3 of h2.getAttributeNames())
            if (i3.endsWith(o$1) || i3.startsWith(n$2)) {
              const s3 = f2[u2++];
              if (t3.push(i3), void 0 !== s3) {
                const t4 = h2.getAttribute(s3.toLowerCase() + o$1).split(n$2), i4 = /([.?@])?(.*)/.exec(s3);
                v2.push({ type: 1, index: r2, name: i4[2], strings: t4, ctor: "." === i4[1] ? k2 : "?" === i4[1] ? I$1 : "@" === i4[1] ? L$1 : R$1 });
              } else
                v2.push({ type: 6, index: r2 });
            }
          for (const i3 of t3)
            h2.removeAttribute(i3);
        }
        if (y$1.test(h2.tagName)) {
          const t3 = h2.textContent.split(n$2), i3 = t3.length - 1;
          if (i3 > 0) {
            h2.textContent = s$2 ? s$2.emptyScript : "";
            for (let s3 = 0; s3 < i3; s3++)
              h2.append(t3[s3], d$1()), C.nextNode(), v2.push({ type: 2, index: ++r2 });
            h2.append(t3[i3], d$1());
          }
        }
      } else if (8 === h2.nodeType)
        if (h2.data === l$3)
          v2.push({ type: 2, index: r2 });
        else {
          let t3 = -1;
          for (; -1 !== (t3 = h2.data.indexOf(n$2, t3 + 1)); )
            v2.push({ type: 7, index: r2 }), t3 += n$2.length - 1;
        }
      r2++;
    }
  }
  static createElement(t2, i2) {
    const s3 = r.createElement("template");
    return s3.innerHTML = t2, s3;
  }
};
function N(t2, i2, s3 = t2, e2) {
  var o4, n2, l2, h2;
  if (i2 === T$1)
    return i2;
  let r2 = void 0 !== e2 ? null === (o4 = s3._$Co) || void 0 === o4 ? void 0 : o4[e2] : s3._$Cl;
  const d4 = u$1(i2) ? void 0 : i2._$litDirective$;
  return (null == r2 ? void 0 : r2.constructor) !== d4 && (null === (n2 = null == r2 ? void 0 : r2._$AO) || void 0 === n2 || n2.call(r2, false), void 0 === d4 ? r2 = void 0 : (r2 = new d4(t2), r2._$AT(t2, s3, e2)), void 0 !== e2 ? (null !== (l2 = (h2 = s3)._$Co) && void 0 !== l2 ? l2 : h2._$Co = [])[e2] = r2 : s3._$Cl = r2), void 0 !== r2 && (i2 = N(t2, r2._$AS(t2, i2.values), r2, e2)), i2;
}
class S2 {
  constructor(t2, i2) {
    this.u = [], this._$AN = void 0, this._$AD = t2, this._$AM = i2;
  }
  get parentNode() {
    return this._$AM.parentNode;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  v(t2) {
    var i2;
    const { el: { content: s3 }, parts: e2 } = this._$AD, o4 = (null !== (i2 = null == t2 ? void 0 : t2.creationScope) && void 0 !== i2 ? i2 : r).importNode(s3, true);
    C.currentNode = o4;
    let n2 = C.nextNode(), l2 = 0, h2 = 0, d4 = e2[0];
    for (; void 0 !== d4; ) {
      if (l2 === d4.index) {
        let i3;
        2 === d4.type ? i3 = new M$1(n2, n2.nextSibling, this, t2) : 1 === d4.type ? i3 = new d4.ctor(n2, d4.name, d4.strings, this, t2) : 6 === d4.type && (i3 = new z$1(n2, this, t2)), this.u.push(i3), d4 = e2[++h2];
      }
      l2 !== (null == d4 ? void 0 : d4.index) && (n2 = C.nextNode(), l2++);
    }
    return o4;
  }
  p(t2) {
    let i2 = 0;
    for (const s3 of this.u)
      void 0 !== s3 && (void 0 !== s3.strings ? (s3._$AI(t2, s3, i2), i2 += s3.strings.length - 2) : s3._$AI(t2[i2])), i2++;
  }
}
let M$1 = class M2 {
  constructor(t2, i2, s3, e2) {
    var o4;
    this.type = 2, this._$AH = A$1, this._$AN = void 0, this._$AA = t2, this._$AB = i2, this._$AM = s3, this.options = e2, this._$Cm = null === (o4 = null == e2 ? void 0 : e2.isConnected) || void 0 === o4 || o4;
  }
  get _$AU() {
    var t2, i2;
    return null !== (i2 = null === (t2 = this._$AM) || void 0 === t2 ? void 0 : t2._$AU) && void 0 !== i2 ? i2 : this._$Cm;
  }
  get parentNode() {
    let t2 = this._$AA.parentNode;
    const i2 = this._$AM;
    return void 0 !== i2 && 11 === (null == t2 ? void 0 : t2.nodeType) && (t2 = i2.parentNode), t2;
  }
  get startNode() {
    return this._$AA;
  }
  get endNode() {
    return this._$AB;
  }
  _$AI(t2, i2 = this) {
    t2 = N(this, t2, i2), u$1(t2) ? t2 === A$1 || null == t2 || "" === t2 ? (this._$AH !== A$1 && this._$AR(), this._$AH = A$1) : t2 !== this._$AH && t2 !== T$1 && this.g(t2) : void 0 !== t2._$litType$ ? this.$(t2) : void 0 !== t2.nodeType ? this.T(t2) : v(t2) ? this.k(t2) : this.g(t2);
  }
  S(t2) {
    return this._$AA.parentNode.insertBefore(t2, this._$AB);
  }
  T(t2) {
    this._$AH !== t2 && (this._$AR(), this._$AH = this.S(t2));
  }
  g(t2) {
    this._$AH !== A$1 && u$1(this._$AH) ? this._$AA.nextSibling.data = t2 : this.T(r.createTextNode(t2)), this._$AH = t2;
  }
  $(t2) {
    var i2;
    const { values: s3, _$litType$: e2 } = t2, o4 = "number" == typeof e2 ? this._$AC(t2) : (void 0 === e2.el && (e2.el = V$1.createElement(e2.h, this.options)), e2);
    if ((null === (i2 = this._$AH) || void 0 === i2 ? void 0 : i2._$AD) === o4)
      this._$AH.p(s3);
    else {
      const t3 = new S2(o4, this), i3 = t3.v(this.options);
      t3.p(s3), this.T(i3), this._$AH = t3;
    }
  }
  _$AC(t2) {
    let i2 = E$1.get(t2.strings);
    return void 0 === i2 && E$1.set(t2.strings, i2 = new V$1(t2)), i2;
  }
  k(t2) {
    c$1(this._$AH) || (this._$AH = [], this._$AR());
    const i2 = this._$AH;
    let s3, e2 = 0;
    for (const o4 of t2)
      e2 === i2.length ? i2.push(s3 = new M2(this.S(d$1()), this.S(d$1()), this, this.options)) : s3 = i2[e2], s3._$AI(o4), e2++;
    e2 < i2.length && (this._$AR(s3 && s3._$AB.nextSibling, e2), i2.length = e2);
  }
  _$AR(t2 = this._$AA.nextSibling, i2) {
    var s3;
    for (null === (s3 = this._$AP) || void 0 === s3 || s3.call(this, false, true, i2); t2 && t2 !== this._$AB; ) {
      const i3 = t2.nextSibling;
      t2.remove(), t2 = i3;
    }
  }
  setConnected(t2) {
    var i2;
    void 0 === this._$AM && (this._$Cm = t2, null === (i2 = this._$AP) || void 0 === i2 || i2.call(this, t2));
  }
};
let R$1 = class R2 {
  constructor(t2, i2, s3, e2, o4) {
    this.type = 1, this._$AH = A$1, this._$AN = void 0, this.element = t2, this.name = i2, this._$AM = e2, this.options = o4, s3.length > 2 || "" !== s3[0] || "" !== s3[1] ? (this._$AH = Array(s3.length - 1).fill(new String()), this.strings = s3) : this._$AH = A$1;
  }
  get tagName() {
    return this.element.tagName;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AI(t2, i2 = this, s3, e2) {
    const o4 = this.strings;
    let n2 = false;
    if (void 0 === o4)
      t2 = N(this, t2, i2, 0), n2 = !u$1(t2) || t2 !== this._$AH && t2 !== T$1, n2 && (this._$AH = t2);
    else {
      const e3 = t2;
      let l2, h2;
      for (t2 = o4[0], l2 = 0; l2 < o4.length - 1; l2++)
        h2 = N(this, e3[s3 + l2], i2, l2), h2 === T$1 && (h2 = this._$AH[l2]), n2 || (n2 = !u$1(h2) || h2 !== this._$AH[l2]), h2 === A$1 ? t2 = A$1 : t2 !== A$1 && (t2 += (null != h2 ? h2 : "") + o4[l2 + 1]), this._$AH[l2] = h2;
    }
    n2 && !e2 && this.j(t2);
  }
  j(t2) {
    t2 === A$1 ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, null != t2 ? t2 : "");
  }
};
class k2 extends R$1 {
  constructor() {
    super(...arguments), this.type = 3;
  }
  j(t2) {
    this.element[this.name] = t2 === A$1 ? void 0 : t2;
  }
}
const H = s$2 ? s$2.emptyScript : "";
let I$1 = class I2 extends R$1 {
  constructor() {
    super(...arguments), this.type = 4;
  }
  j(t2) {
    t2 && t2 !== A$1 ? this.element.setAttribute(this.name, H) : this.element.removeAttribute(this.name);
  }
};
let L$1 = class L2 extends R$1 {
  constructor(t2, i2, s3, e2, o4) {
    super(t2, i2, s3, e2, o4), this.type = 5;
  }
  _$AI(t2, i2 = this) {
    var s3;
    if ((t2 = null !== (s3 = N(this, t2, i2, 0)) && void 0 !== s3 ? s3 : A$1) === T$1)
      return;
    const e2 = this._$AH, o4 = t2 === A$1 && e2 !== A$1 || t2.capture !== e2.capture || t2.once !== e2.once || t2.passive !== e2.passive, n2 = t2 !== A$1 && (e2 === A$1 || o4);
    o4 && this.element.removeEventListener(this.name, this, e2), n2 && this.element.addEventListener(this.name, this, t2), this._$AH = t2;
  }
  handleEvent(t2) {
    var i2, s3;
    "function" == typeof this._$AH ? this._$AH.call(null !== (s3 = null === (i2 = this.options) || void 0 === i2 ? void 0 : i2.host) && void 0 !== s3 ? s3 : this.element, t2) : this._$AH.handleEvent(t2);
  }
};
let z$1 = class z2 {
  constructor(t2, i2, s3) {
    this.element = t2, this.type = 6, this._$AN = void 0, this._$AM = i2, this.options = s3;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AI(t2) {
    N(this, t2);
  }
};
const j = i$1.litHtmlPolyfillSupport;
null == j || j(V$1, M$1), (null !== (t = i$1.litHtmlVersions) && void 0 !== t ? t : i$1.litHtmlVersions = []).push("2.7.0");
const B = (t2, i2, s3) => {
  var e2, o4;
  const n2 = null !== (e2 = null == s3 ? void 0 : s3.renderBefore) && void 0 !== e2 ? e2 : i2;
  let l2 = n2._$litPart$;
  if (void 0 === l2) {
    const t3 = null !== (o4 = null == s3 ? void 0 : s3.renderBefore) && void 0 !== o4 ? o4 : null;
    n2._$litPart$ = l2 = new M$1(i2.insertBefore(d$1(), t3), t3, void 0, null != s3 ? s3 : {});
  }
  return l2._$AI(t2), l2;
};
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var l$2, o3;
let s$1 = class s extends d$2 {
  constructor() {
    super(...arguments), this.renderOptions = { host: this }, this._$Do = void 0;
  }
  createRenderRoot() {
    var t2, e2;
    const i2 = super.createRenderRoot();
    return null !== (t2 = (e2 = this.renderOptions).renderBefore) && void 0 !== t2 || (e2.renderBefore = i2.firstChild), i2;
  }
  update(t2) {
    const i2 = this.render();
    this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t2), this._$Do = B(i2, this.renderRoot, this.renderOptions);
  }
  connectedCallback() {
    var t2;
    super.connectedCallback(), null === (t2 = this._$Do) || void 0 === t2 || t2.setConnected(true);
  }
  disconnectedCallback() {
    var t2;
    super.disconnectedCallback(), null === (t2 = this._$Do) || void 0 === t2 || t2.setConnected(false);
  }
  render() {
    return T$1;
  }
};
s$1.finalized = true, s$1._$litElement$ = true, null === (l$2 = globalThis.litElementHydrateSupport) || void 0 === l$2 || l$2.call(globalThis, { LitElement: s$1 });
const n$1 = globalThis.litElementPolyfillSupport;
null == n$1 || n$1({ LitElement: s$1 });
(null !== (o3 = globalThis.litElementVersions) && void 0 !== o3 ? o3 : globalThis.litElementVersions = []).push("3.3.0");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const e$2 = (e2) => (n2) => "function" == typeof n2 ? ((e3, n3) => (customElements.define(e3, n3), n3))(e2, n2) : ((e3, n3) => {
  const { kind: t2, elements: s3 } = n3;
  return { kind: t2, elements: s3, finisher(n4) {
    customElements.define(e3, n4);
  } };
})(e2, n2);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const i = (i2, e2) => "method" === e2.kind && e2.descriptor && !("value" in e2.descriptor) ? { ...e2, finisher(n2) {
  n2.createProperty(e2.key, i2);
} } : { kind: "field", key: Symbol(), placement: "own", descriptor: {}, originalKey: e2.key, initializer() {
  "function" == typeof e2.initializer && (this[e2.key] = e2.initializer.call(this));
}, finisher(n2) {
  n2.createProperty(e2.key, i2);
} };
function e$1(e2) {
  return (n2, t2) => void 0 !== t2 ? ((i2, e3, n3) => {
    e3.constructor.createProperty(n3, i2);
  })(e2, n2, t2) : i(e2, n2);
}
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var n;
null != (null === (n = window.HTMLSlotElement) || void 0 === n ? void 0 : n.prototype.assignedElements) ? (o4, n2) => o4.assignedElements(n2) : (o4, n2) => o4.assignedNodes(n2).filter((o5) => o5.nodeType === Node.ELEMENT_NODE);
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const l$1 = (l2) => null != l2 ? l2 : A$2;
const d3 = "^(?:(?:https?):)?(?://)?[^/]*(?:youtube(?:-nocookie)?.com|youtu.be).*[=/]([-\\w]{11})(?:\\?|=|&|$)", a = (t2) => {
  var o4;
  return t2 ? ((o4 = t2.match(d3)) == null ? void 0 : o4[1]) ?? "" : "";
}, u = (t2) => `https://www.youtube.com/embed/${t2}`, p = /(?:(?:https?):)?(?:\/\/)?(?:embed\.|open\.)(?:spotify\.com\/)(?:(album|track|playlist)\/|\?uri=spotify:track:)((\w|-){22})/, l = /spotify:(?:(album|track|playlist):|\?uri=spotify:track:)((\w|-){22})/, y = (t2) => {
  const [, o4, r2] = t2.match(p) || t2.match(l) || [];
  return [r2, o4];
}, f = (t2, o4) => `https://open.spotify.com/embed/${o4}/${t2}`, g = /(?:(?:https?):)?(?:\/\/)?(?:www\.|player\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^/]*)\/videos\/|video\/|)(\d+)(?:|\/\?)/, b = (t2) => {
  var o4;
  return ((o4 = t2.match(g)) == null ? void 0 : o4[1]) ?? "";
}, h = (t2) => `https://player.vimeo.com/video/${t2}`, w = /^(?:(?:https?):)?(?:\/\/)?(?:www\.)?(?:(?:dailymotion\.com(?:\/embed)?\/video)|dai\.ly)\/([a-zA-Z0-9]+)(?:_[\w_-]+)?(?:\?playlist=[a-zA-Z0-9]+)?$/, U = (t2) => {
  var o4;
  return ((o4 = t2.match(w)) == null ? void 0 : o4[1]) ?? "";
}, z3 = (t2) => `https://www.dailymotion.com/embed/video/${t2}`, E = new RegExp(
  "^(?:(?:https?):)?(?://)?[^/]*edpuzzle.com.*[=/]media/([-\\w]+)"
), I3 = (t2) => {
  var o4;
  return t2 ? ((o4 = t2.match(E)) == null ? void 0 : o4[1]) ?? "" : "";
}, F = (t2) => `https://edpuzzle.com/embed/media/${t2}`, R3 = new RegExp(
  "^(?:(?:https?):)?(?://)?[^/]*loom.com.*[=/]share/([-\\w]+)"
), s2 = (t2) => {
  var o4;
  return t2 ? ((o4 = t2.match(R3)) == null ? void 0 : o4[1]) ?? "" : "";
}, x = (t2) => `https://www.loom.com/embed/${t2}`, T = new RegExp(
  "^(?:(?:https?):)?(?://)?[^/]*(?:wistia.com|wi.st).*[=/](?:medias|embed)/([-\\w]+)"
  // '^(?:(?:https?):)?(?://)?[^/]*wistia.com.*[=/]medias/([-\\w]+)'  // v1 (handcrafted by Tony)
), c = (t2) => {
  var o4;
  return t2 ? ((o4 = t2.match(T)) == null ? void 0 : o4[1]) ?? "" : "";
}, $ = (t2) => `https://fast.wistia.net/embed/iframe/${t2}`;
var e = /* @__PURE__ */ ((t2) => (t2.YouTube = "YouTube", t2.Spotify = "Spotify", t2.Vimeo = "Vimeo", t2.DailyMotion = "DailyMotion", t2.EdPuzzle = "EdPuzzle", t2.Loom = "Loom", t2.Wistia = "Wistia", t2))(e || {});
const M3 = (t2) => {
  if (t2) {
    if (t2.match(/dailymotion/))
      return e.DailyMotion;
    if (t2.match(/spotify/))
      return e.Spotify;
    if (t2.match(/vimeo/))
      return e.Vimeo;
    if (t2.match(/youtu\.?be/))
      return e.YouTube;
    if (t2.match(/edpuzzle.com/))
      return e.EdPuzzle;
    if (c(t2))
      return e.Wistia;
    if (s2(t2))
      return e.Loom;
  }
};
({
  [e.DailyMotion]: U,
  [e.Spotify]: y,
  [e.Vimeo]: b,
  [e.YouTube]: a,
  [e.EdPuzzle]: I3,
  [e.Loom]: s2,
  [e.Wistia]: c
});
({
  [e.DailyMotion]: z3,
  [e.Spotify]: f,
  [e.Vimeo]: h,
  [e.YouTube]: u,
  [e.EdPuzzle]: F,
  [e.Loom]: x,
  [e.Wistia]: $
});
const V3 = (t2) => typeof t2 == "string", D = (t2) => t2 instanceof RegExp, L3 = (t2) => (o4) => V3(o4) && !D(t2) ? o4.includes(t2) : new RegExp(t2).test(o4), W = /^[a-z][a-z\d.+-]*:\/*(?:[^:@]+(?::[^@]+)?@)?(?:[^\s:/?#]+|\[[a-f\d:]+])(?::\d+)?(?:\/[^?#]*)?(?:\?[^#]*)?(?:#.*)?$/i, A = L3(W);
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i2 = decorators.length - 1, decorator; i2 >= 0; i2--)
    if (decorator = decorators[i2])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let OEmbedElement = class extends s$1 {
  constructor() {
    super(...arguments);
    this.width = "560";
    this.height = "315";
    this.frameborder = "0";
    this.allowfullscreen = "true";
  }
  instanceStyle() {
    const { widthWithUnits, heightWithUnits } = this.getDefaultDimensions(
      this.provider
    );
    return x$1`
      <style>
        :host {
          border: 0;
          padding: 0;
          display: block;
        }
        iframe {
          width: var(--social-embed-iframe-width, ${widthWithUnits});
          height: var(--social-embed-iframe-height, ${heightWithUnits});
        }
      </style>
    `;
  }
  render() {
    this.provider = M3(this.url);
    if (!this.url || this.url == "") {
      return x$1``;
    }
    let embedResult;
    switch (this.provider) {
      case e.YouTube:
        embedResult = this.renderYouTube();
        break;
      case e.Spotify:
        embedResult = this.renderSpotify();
        break;
      case e.Vimeo:
        embedResult = this.renderVimeo();
        break;
      case e.DailyMotion:
        embedResult = this.renderDailyMotion();
        break;
      case e.EdPuzzle:
        embedResult = this.renderEdPuzzle();
        break;
      case e.Wistia:
        embedResult = this.renderWistia();
        break;
      case e.Loom:
        embedResult = this.renderLoom();
        break;
      default:
        if (A(this.url)) {
          embedResult = this.renderIframe();
        } else {
          embedResult = x$1`No provider found for ${this.url}`;
        }
        break;
    }
    return x$1`${this.instanceStyle()}${embedResult}`;
  }
  renderSpotify() {
    const url = f(
      ...y(this.url)
    );
    return x$1`
      <iframe
        src="${url}"
        width="${this.width}"
        frameborder=${l$1(
      this.frameborder ? this.frameborder : void 0
    )}
        height="${this.height}"
        allowtransparency="true"
        allow="encrypted-media"
      ></iframe>
      <slot></slot>
    `;
  }
  getDefaultDimensions(provider) {
    switch (provider) {
      case e.Vimeo:
        return this.calculateDefaultDimensions({
          defaults: OEmbedElement.vimeoDefaultDimensions
        });
      case e.DailyMotion:
        return this.calculateDefaultDimensions();
      case e.EdPuzzle:
        return this.calculateDefaultDimensions({
          defaults: OEmbedElement.edPuzzleDefaultDimensions
        });
      case e.Wistia:
        return this.calculateDefaultDimensions({
          defaults: OEmbedElement.wistiaDefaultDimensions
        });
      case e.Loom:
        return this.calculateDefaultDimensions({
          defaults: OEmbedElement.loomDefaultDimensions
        });
      default:
        return this.calculateDefaultDimensions();
    }
  }
  calculateDefaultDimensions({
    defaults
  } = { defaults: void 0 }) {
    const width = this.getAttribute("width") || (defaults == null ? void 0 : defaults.width) || this.width;
    const widthWithUnits = width.match(/(px|%)/) ? width : `${width}px`;
    const height = this.getAttribute("height") || (defaults == null ? void 0 : defaults.height) || this.height;
    const heightWithUnits = height.match(/(px|%)/) ? height : `${height}px`;
    return { width, widthWithUnits, height, heightWithUnits };
  }
  renderDailyMotion() {
    const dailyMotionId = U(this.url);
    if (!dailyMotionId) {
      return x$1`Could not find dailyMotionId in ${dailyMotionId}`;
    }
    const url = z3(dailyMotionId);
    const { width, height } = this.getDefaultDimensions(this.provider);
    return x$1`
      <iframe
        allow="autoplay"
        width="${width}"
        height="${height}"
        src="${url}"
        frameborder=${l$1(
      this.frameborder ? this.frameborder : void 0
    )}
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen=${l$1(
      this.allowfullscreen === "" || this.allowfullscreen == "true" || this.allowfullscreen === "true" || this.allowfullscreen === true || this.allowfullscreen === "1" ? true : void 0
    )}
        type="text/html"
      ></iframe>
      <slot></slot>
    `;
  }
  renderVimeo() {
    const vimeoId = b(this.url);
    if (!vimeoId) {
      return x$1`Could not find vimeoId in ${vimeoId}`;
    }
    const url = h(vimeoId);
    const { width, height } = this.getDefaultDimensions(this.provider);
    return x$1`
      <iframe
        width="${width}"
        height="${height}"
        src="${url}"
        frameborder=${l$1(
      this.frameborder ? this.frameborder : void 0
    )}
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen=${l$1(
      this.allowfullscreen === "" || this.allowfullscreen == "true" || this.allowfullscreen === "true" || this.allowfullscreen === true || this.allowfullscreen === "1" ? true : void 0
    )}
      ></iframe>
      <slot></slot>
    `;
  }
  renderYouTube() {
    const youtubeId = a(this.url);
    const youtubeUrl = u(youtubeId);
    if (!youtubeId) {
      return x$1``;
    }
    return x$1`
      <iframe
        width="${this.width}"
        height="${this.height}"
        src="${youtubeUrl}"
        frameborder=${l$1(
      this.frameborder ? this.frameborder : void 0
    )}
        allowfullscreen=${l$1(
      this.allowfullscreen === "" || this.allowfullscreen == "true" || this.allowfullscreen === "true" || this.allowfullscreen === true || this.allowfullscreen === "1" ? true : void 0
    )}
      ></iframe>
      <slot></slot>
    `;
  }
  renderIframe() {
    const { width, height } = this.getDefaultDimensions(this.provider);
    return x$1`
      <iframe
        width="${width}"
        height="${height}"
        src="${this.url}"
        frameborder=${l$1(
      this.frameborder ? this.frameborder : void 0
    )}
      ></iframe>
      <slot></slot>
    `;
  }
  renderEdPuzzle() {
    if (!this.url) {
      return x$1`No url found for embed`;
    }
    const embedId = I3(this.url);
    if (!embedId) {
      return x$1`No ID found for ${this.url}`;
    }
    const embedUrl = F(embedId);
    const { width, height } = this.getDefaultDimensions(this.provider);
    return x$1`
      <iframe
        width="${width}"
        height="${height}"
        src="${embedUrl}"
        frameborder=${l$1(
      this.frameborder ? this.frameborder : void 0
    )}
        allowfullscreen=${l$1(
      this.allowfullscreen === "" || this.allowfullscreen == "true" || this.allowfullscreen === "true" || this.allowfullscreen === true || this.allowfullscreen === "1" ? true : void 0
    )}
      ></iframe>
      <slot></slot>
    `;
  }
  renderWistia() {
    if (!this.url) {
      return x$1`No url found for embed`;
    }
    const embedId = c(this.url);
    if (!embedId) {
      return x$1`No ID found for ${this.url}`;
    }
    const embedUrl = $(embedId);
    const { width, height } = this.getDefaultDimensions(this.provider);
    return x$1`
      <iframe
        width="${width}"
        height="${height}"
        src="${embedUrl}"
        frameborder=${l$1(
      this.frameborder ? this.frameborder : void 0
    )}
        allowfullscreen=${l$1(
      this.allowfullscreen === "" || this.allowfullscreen == "true" || this.allowfullscreen === "true" || this.allowfullscreen === true || this.allowfullscreen === "1" ? true : void 0
    )}
      ></iframe>
      <slot></slot>
    `;
  }
  renderLoom() {
    if (!this.url) {
      return x$1`No url found for embed`;
    }
    const embedId = s2(this.url);
    if (!embedId) {
      return x$1`No ID found for ${this.url}`;
    }
    const embedUrl = x(embedId);
    const { width, height } = this.getDefaultDimensions(this.provider);
    return x$1`
      <iframe
        width="${width}"
        height="${height}"
        src="${embedUrl}"
        frameborder=${l$1(
      this.frameborder ? this.frameborder : void 0
    )}
        allowfullscreen=${l$1(
      this.allowfullscreen === "" || this.allowfullscreen == "true" || this.allowfullscreen === "true" || this.allowfullscreen === true || this.allowfullscreen === "1" ? true : void 0
    )}
      ></iframe>
      <slot></slot>
    `;
  }
};
OEmbedElement.vimeoDefaultDimensions = {
  width: "640",
  widthWithUnits: "640px",
  height: "268",
  heightWithUnits: "268"
};
OEmbedElement.edPuzzleDefaultDimensions = {
  width: "470",
  widthWithUnits: "470px",
  height: "404",
  heightWithUnits: "404px"
};
OEmbedElement.wistiaDefaultDimensions = {
  width: "470",
  widthWithUnits: "470px",
  height: "404",
  heightWithUnits: "404px"
};
OEmbedElement.loomDefaultDimensions = {
  width: "470",
  widthWithUnits: "470px",
  height: "404",
  heightWithUnits: "404px"
};
__decorateClass([
  e$1({ type: String })
], OEmbedElement.prototype, "url", 2);
__decorateClass([
  e$1({ type: String })
], OEmbedElement.prototype, "width", 2);
__decorateClass([
  e$1({ type: String })
], OEmbedElement.prototype, "height", 2);
__decorateClass([
  e$1({ type: String })
], OEmbedElement.prototype, "frameborder", 2);
__decorateClass([
  e$1({ type: String })
], OEmbedElement.prototype, "allowfullscreen", 2);
OEmbedElement = __decorateClass([
  e$2("o-embed")
], OEmbedElement);
export {
  OEmbedElement
};
